module.exports = "/_next/static/media/ce906e9c85cbe0bde1887846076c4d67.svg";